// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { isCanada } from '@tcp/core/src/utils/utils';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Button from '@tcp/core/src/components/common/atoms/Button';
import { routerPush } from '@tcp/core/src/utils';
import withStyles from '../../../../../../common/hoc/withStyles';
import internalEndpoints from '../../../internalEndpoints';
import styles from '../styles/MyOffersCoupons.view.style';
import Anchor from '../../../../../../common/atoms/Anchor';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
  lblShopNow,
} from '../../../../../../../utils/labels/globalGeneric.labels';
import AccountCommonLabels, { GLOBAL_LABELS } from '../../../labels/AccountCommon.labels';

/**
 * This component will render EmptyOffersList component
 * @param { string, object }
 */
export const EmptyOffersList = ({ className, closedOverlay, newRewardsAndOffers }) => {
  const globalLabels = getLabelFromCopyOrFromTranslation(GLOBAL_LABELS, AccountCommonLabels);

  /**
   * This function will handle click to go to homepage
   * @param {} -
   */
  const goToHomePage = () => {
    routerPush(internalEndpoints.shopNowPage.link, internalEndpoints.shopNowPage.path);
    closedOverlay();
  };

  const couponDescription = isCanada()
    ? renderLabel(
        globalLabels?.placeRewards?.lbl_my_rewards_emptySupportingText,
        'lbl_my_rewards_emptySupportingText'
      )
    : renderLabel(
        globalLabels?.accountDrawer?.lbl_accoundDashboard_noRewardsOffers,
        'lbl_accoundDashboard_noRewardsOffers'
      );

  const emptyWalletLabel = isCanada()
    ? renderLabel(
        globalLabels?.placeRewards?.lbl_my_rewards_emptySupportingText,
        'lbl_my_rewards_emptySupportingText'
      )
    : renderLabel(
        globalLabels?.placeRewards?.lbl_my_rewards_emptySupportingText_US,
        'lbl_my_rewards_emptySupportingText_US'
      );
  return (
    <BodyCopy className={className}>
      {newRewardsAndOffers ? (
        <BodyCopy component="div" className="rewards-empty-container">
          <BodyCopy className="rewards-heading">{couponDescription}</BodyCopy>
          <Anchor
            className="rewards-link"
            to={'/home'}
            asPath={'/home'}
            target={'_self'}
            dataLocator={'accountverview-earnExtaPointTitle-viewallcta'}
            fontSize="fs16"
            anchorVariation="primary"
            underline
          >
            {renderLabel(globalLabels?.recommendations?.CTA_TEXT, 'CTA_TEXT')}
          </Anchor>
        </BodyCopy>
      ) : (
        <>
          <BodyCopy
            dataLocator="rewards-no-rewards-info"
            fontFamily="secondary"
            fontSize="fs14"
            component="p"
            fontWeight="regular"
            className="elem-mb-LRG"
          >
            {emptyWalletLabel}
          </BodyCopy>
          <BodyCopy component="div" className="coupon_viewall_tile elem-mb-LRG">
            <Button
              className="coupon_button_black shop-btn"
              buttonVariation="variable-width"
              type="submit"
              onClick={goToHomePage}
              data-locator="my-rewards-shop-now-btn"
            >
              {renderLabel(
                getLabelFromCopyOrFromTranslation(
                  `${GLOBAL_GENERIC_LABELS}.${lblShopNow}`,
                  GlobalGenericLabels
                ),
                'lbl_shop_now'
              )}
            </Button>
          </BodyCopy>
        </>
      )}
    </BodyCopy>
  );
};

EmptyOffersList.propTypes = {
  className: PropTypes.string,
  closedOverlay: PropTypes.func,
  commonLabels: PropTypes.shape({}).isRequired,
  newRewardsAndOffers: PropTypes.bool,
};

EmptyOffersList.defaultProps = {
  className: '',
  closedOverlay: () => {},
  newRewardsAndOffers: false,
};

export default withStyles(EmptyOffersList, styles);
